import { createAsyncThunk } from '@reduxjs/toolkit';
import CollectionService from '../../../api/services/CollectionService';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../utils/constants';

export const fetchCollections = createAsyncThunk('collections/fetchCollections', async ({ influencerId }) => {
  return await CollectionService.fetchCollections(influencerId);
});

export const createCollection = createAsyncThunk('collections/createCollection', async ({ name, influencerId }) => {
  return await CollectionService.createCollection(name, influencerId);
});

export const fetchCollectionUsers = createAsyncThunk(
  'collections/fetchCollectionUsers',
  async ({ collectionId, page, search, influencerId }) => {
    return await CollectionService.fetchCollectionUsers(collectionId, page, search, influencerId);
  },
);

export const fetchInfluencerChats = createAsyncThunk(
  'collections/fetchInfluencerChats',
  async ({ collectionId, page, search, influencerId }) => {
    return await CollectionService.fetchInfluencerChats(page, search, collectionId, influencerId);
  },
);

export const fetchInfluencerChat = createAsyncThunk(
  'collections/fetchInfluencerChat',
  async ({ userInfluencerId, cursor, influencerId, bidirectional }) => {
    return await CollectionService.fetchInfluencerChat(cursor, userInfluencerId, influencerId, bidirectional);
  },
);

export const sendMessage = createAsyncThunk(
  'collections/sendMessage',
  async ({ userInfluencerId, body, influencerId }) => {
    return await CollectionService.sendMessage(userInfluencerId, body, influencerId);
  },
);

export const sendMassDMMessage = createAsyncThunk('collections/sendMassDMMessage', async ({ body, influencerId }) => {
  return await CollectionService.sendMassDMMessage(body, influencerId);
});

export const pinUser = createAsyncThunk('collections/pinUser', async ({ userInfluencerId, influencerId }) => {
  return await CollectionService.pinUser(userInfluencerId, influencerId);
});

export const editDisplayName = createAsyncThunk(
  'collections/editDisplayName',
  async ({ userInfluencerId, name, influencerId }) => {
    return await CollectionService.editDisplayName(userInfluencerId, name, influencerId);
  },
);

export const markChatAsRead = createAsyncThunk(
  'collections/markChatAsRead',
  async ({ userInfluencerId, influencerId }) => {
    return await CollectionService.markChatAsRead(userInfluencerId, influencerId);
  },
);

export const addUserToCollection = createAsyncThunk(
  'collections/addUserToCollection',
  async ({ userInfluencerId, collectionId, influencerId }) => {
    return await CollectionService.addUserToCollection(userInfluencerId, collectionId, influencerId);
  },
);

export const fetchNotifications = createAsyncThunk(
  'collections/fetchNotifications',
  async ({ page, perPage, influencerId }) => {
    return await CollectionService.fetchNotifications(page, perPage, influencerId);
  },
);

export const fetchInfluencerNotificationStatus = createAsyncThunk(
  'collections/fetchInfluencerNotificationStatus',
  async ({ influencerId }) => {
    return await CollectionService.fetchInfluencerNotificationStatus(influencerId);
  },
  {
    condition: (_, { getState }) => {
      return [
        CRM_ORGANIZATION_MEMBER_ROLE.OWNER,
        CRM_ORGANIZATION_MEMBER_ROLE.ADMINISTRATOR,
        CRM_ORGANIZATION_MEMBER_ROLE.TEAM_LEAD,
        CRM_ORGANIZATION_MEMBER_ROLE.REVIEWER,
      ].includes(getState().userInfo.user?.role);
    },
  },
);

export const toggleUserInfluencerManualChat = createAsyncThunk(
  'collections/toggleUserInfluencerManualChat',
  async ({ influencerId, userInfluencerId }) => {
    return await CollectionService.toggleUserInfluencerManualChat(userInfluencerId, influencerId);
  },
);

export const getAiChatSuggestions = createAsyncThunk(
  'collections/getAiChatSuggestions',
  async ({ influencerId, userInfluencerId, manualFlowInstructionType }) => {
    return await CollectionService.getAiChatSuggestions(userInfluencerId, influencerId, manualFlowInstructionType);
  },
);

export const unblockUserInfluencerChat = createAsyncThunk(
  'collections/unblockUserInfluencerChat',
  async ({ influencerId, userInfluencerId }) => {
    return await CollectionService.unblockUserInfluencerChat(userInfluencerId, influencerId);
  },
);

export const fetchInfluencerMassDmHistory = createAsyncThunk(
  'collections/fetchInfluencerMassDmHistory',
  async ({ page, influencerId }) => {
    return await CollectionService.fetchInfluencerMassDmHistory(page, influencerId);
  },
);

export const cancelInfluencerManualMassDm = createAsyncThunk(
  'collections/cancelInfluencerManualMassDm',
  async ({ massDmId, influencerId }) => {
    return await CollectionService.cancelInfluencerManualMassDm(massDmId, influencerId);
  },
);
